// Parsing
export { parseRaceChronoCsv, splitCsvLine } from './parse/racechrono-csv.js';
export {
  parseRcz,
  parseRaceChronoFile,
  parseRczNative,
  isNativeRcz,
  isZip,
  type RczLap,
  type RczNativeMeta,
} from './parse/rcz.js';
export { parseRczTelemetry } from './parse/rcz-binary.js';
export {
  buildColumnSpecs,
  pickCanonicalSpeed,
  normaliseSource,
  groupForSource,
  type ColumnSpec,
} from './parse/channels.js';

// Analysis
export { getChannel, interpolateNaN, resampleLap, lapLength, lapStartDistance } from './analysis/laps.js';
export { computeBrakeChannel, withDerivedChannels } from './analysis/derived.js';
export { deltaTime } from './analysis/delta.js';
export { computeSectorDistances } from './analysis/sectors.js';
export { lapStats, summariseSession, sectorTimes } from './analysis/stats.js';
export { haversine, projectLocal, unprojectLocal, segmentsIntersect } from './analysis/geo.js';

// Serialisation
export { serializeSessionData, deserializeSessionData } from './serialize/session.js';

/** Convert metres/second to kilometres/hour. */
export function toKmh(ms: number): number {
  return ms * 3.6;
}
